import { v4 as uuid } from 'uuid'

export default class Storage {
  constructor () {
    this.prefix = 'reports_'
    this.storage = null

    if (this._testLocalStorage() === true) {
      this.storage = window.localStorage
    }
  }

  _testLocalStorage () {
    try {
      var storage = window.localStorage
      var x = '__storage_test__'
      storage.setItem(x, x)
      storage.removeItem(x)
      return true
    } catch(e) {
      return (e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage.length !== 0)
    }
  }

  /* PUBLIC API */
  createReport (report) {
    if (this.storage === null) {
      return Promise.reject(new Error('No local storage driver present'))
    }

    const id = uuid()
    report.id = id
    report.createdAt = new Date().toISOString()
    report.updatedAt = new Date().toISOString()

    this.storage.setItem(`${this.prefix}${id}`, JSON.stringify(report))
    return Promise.resolve(id)
  }

  deleteReport (id) {
    if (this.storage === null) {
      return Promise.reject(new Error('No local storage driver present'))
    }

    try {
      this.storage.removeItem(`${this.prefix}${id}`)
      return Promise.resolve(true)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  getReport (id) {
    if (this.storage === null) {
      return Promise.reject(new Error('No local storage driver present'))
    }

    try {
      const item = JSON.parse(this.storage.getItem(`${this.prefix}${id}`))
      return Promise.resolve(item)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  getReports () {
    if (this.storage === null) {
      return Promise.reject(new Error('No local storage driver present'))
    }

    const data = []

    try {
      console.log('this.storage.length', this.storage.length)

      for (let key in this.storage) {
        if (key.includes(this.prefix)) {
          data.push(JSON.parse(this.storage.getItem(key)))
        }
      }

      return Promise.resolve(data)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  clearReports () {
    if (this.storage === null) {
      return Promise.reject(new Error('No local storage driver present'))
    }

    try {
      for (let i; i < this.storage.length; i++) {
        const key = this.storage.key(i)

        if (key.includes(this.prefix)) {
          this.storage.removeItem(key)
        }
      }

      if (this.storage.length === 0) {
        return Promise.resolve(true)
      } else {
        return Promise.reject(new Error(`Failed to remove all keys from localStorage: ${this.storage.length} keys left.`))
      }
    } catch (e) {
      return Promise.reject(e)
    }
  }
}



// WEBPACK FOOTER //
// ./lib/localstorage.js